const trainingPlansHeader = {
  "training-plans.header.start": "Create plan",
  "training-plans.header.progress": "{{ completed }}/{{ required }}",
  "training-plans.header.complete": "WEEK COMPLETE",
  "training-plans.header.loading": "LOADING PLAN",
  "training-plans.header.unavailable": "TRAINING PLAN",
  "training-plans.header.label": "Training plan: {{ status }}",
  "training-plans.header.label-with-streak": "Training plan: {{ status }}, {{ count }} week streak",
};

const trainingPlansDrawer = {
  "training-plans.drawer.title": "Your Training Plan",
  "training-plans.drawer.action.edit": "Edit training plan",
  "training-plans.drawer.action.close": "Close training plan",
  "training-plans.drawer.loading.title": "Loading your training plan",
  "training-plans.drawer.loading.description": "We're loading your personal training plan...",
  "training-plans.drawer.building.title": "Building your training plan",
  "training-plans.drawer.building.description": "We're analyzing your level to build your personal training plan...",
  "training-plans.drawer.streak": "{{ count }} week streak",
  "training-plans.drawer.progress.title": "Weekly progress",
  "training-plans.drawer.progress.complete-message": "Nice work! Your weekly plan is complete. A new plan will appear next week.",
  "training-plans.drawer.entries.title": "This week",
  "training-plans.drawer.entry.day": "Day {{ day }}",
  "training-plans.drawer.entry.completed-on": "Completed on {{ date }}",
  "training-plans.drawer.entry.recommended-session": "Recommended training session",
  "training-plans.drawer.entry.match-play": "Match Play",
  "training-plans.drawer.entry.career": "Career",
  "training-plans.drawer.entry.challenges": "Challenges",
  "training-plans.drawer.entry.practice": "Practice",
  "training-plans.drawer.entry.practice.count": "{{ count }} scenarios",
};

const trainingPlansOnboarding = {
  "training-plans.onboarding.loading.title": "Loading training plan options",
  "training-plans.onboarding.loading.description": "We're preparing your personalized training plan choices.",
  "training-plans.onboarding.intro.title": "Introducing Training Plans",
  "training-plans.onboarding.intro.description": "Get a personalized training plan designed to help you stay consistent and track your progress.",
  "training-plans.onboarding.intro.start": "Get started",
  "training-plans.onboarding.intro.not-interested": "Not interested",
  "training-plans.onboarding.profile.title": "Starting Point",
  "training-plans.onboarding.profile.description": "Choose the option that best matches your current scanning level.",
  "training-plans.onboarding.profile.continue": "Continue",
  "training-plans.onboarding.frequency.title": "Frequency",
  "training-plans.onboarding.frequency.description": "Choose how often you want to train each week.",
  "training-plans.onboarding.frequency.option": "{{ count }} {{ unit }} a week",
  "training-plans.onboarding.frequency.unit.singular": "time",
  "training-plans.onboarding.frequency.unit.plural": "times",
  "training-plans.onboarding.frequency.suggested": "Suggested",
  "training-plans.onboarding.frequency.loading": "Saving plan",
  "training-plans.onboarding.frequency.submit.update": "Update training plan",
  "training-plans.onboarding.frequency.submit.create": "Create training plan",
  "training-plans.onboarding.error.unavailable.title": "Training plan unavailable",
  "training-plans.onboarding.error.unavailable.message": "We could not find an available training plan for your selection.",
  "training-plans.onboarding.error.update.title": "Could not update training plan",
  "training-plans.onboarding.error.update.message": "Please try again in a moment.",
};

const trainingPlansToast = {
  "training-plans.toast.progress.title": "Training Plan Progress",
  "training-plans.toast.progress.message": "Great work. You have completed {{ completed }} of {{ required }} sessions this week.",
  "training-plans.toast.complete.title": "Training Plan Complete",
  "training-plans.toast.complete.message": "Awesome job! Your weekly training plan is complete.",
};

export const trainingPlans = {
  ...trainingPlansHeader,
  ...trainingPlansDrawer,
  ...trainingPlansOnboarding,
  ...trainingPlansToast,
};
